import React from 'react';
import { compose, withHandlers, withState } from 'recompose';
import { withSpinnerOnAjax } from '../../Common/Spinner';
import { addEphotobookToCart } from '../../Common/Providers/EPhotobookApi';
import { HTMLTrans } from '../../Common/Translations';
import { withDataLayerAddToCart } from '../../Common/GTM/ECommerceTracking/withDataLayerAddToCart';
import Modal from '../../Common/Modal';
import Auth from '../../Auth';

const withBuyThisHandler = compose(
  withSpinnerOnAjax('addEphotobookToCart', addEphotobookToCart),
  withDataLayerAddToCart,
  withState('openModal', 'setOpenModal', false),
  withHandlers({
    onClick: ({
      file,
      addEphotobookToCart,
      dataLayerAddToCart,
      page,
      setOpenModal
    }) => () => {
      setOpenModal(false)
      addEphotobookToCart({ file })
        .done(({
          data: {
            cart: {
              currency_code: currencyCode,
              cart_item: {
                product: {
                  product_config: productConfig = '',
                  product_name: productName = '',
                  product_family_name: productFamilyName = ''
                },
                unit_price: unitPrice
              }
            },
            redirect_to_cart_url: redirectToCartUrl
          }
        }) => {
          const data = {
            currencyCode,
            product: {
              id: productConfig,
              name: productName,
              category: productFamilyName,
              price: unitPrice,
              variant: productConfig,
              quantity: 1
            },
            sourceOfAddingToCart: `EPhotobook - ${page} page`
          };
          dataLayerAddToCart(data);
          window.location = redirectToCartUrl;
        });
    }
  }),
);

const BuyThisButton = ({ isLoggedIn, onClick, openModal, setOpenModal, page }) => (
  <div className="d-flex justify-content-center">
    {<Modal size="md" modalId="modal" open={openModal} onClose={() => setOpenModal(false)}>
      {closeModal => (
        <Auth
          onTokenUpdate={onClick}
          closeModal={closeModal} />
      )}
    </Modal>}
    <button
    type='button'
    onClick={isLoggedIn ? onClick : () => setOpenModal(true)}
    className='btn btn-primary buy-this-btn'>
    <HTMLTrans id={`${page}.ephotobook_buy_this_btn`}>Buy This</HTMLTrans>
    </button>
  </div>
);

export default withBuyThisHandler(BuyThisButton);



// WEBPACK FOOTER //
// ./src/Account/EPhotobook/EPhotobookBuyThis.js